/**
 * @file WorkWithUs.jsx
 * @description Work with Us page
 */

import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import HeroImage from '../new_images/pexels-kampus-8636589.jpg';

const WorkWithUs = () => {
  return (
    <div>
      <Helmet>
        <title>Work with Us | Bellefy Insights</title>
        <meta
          name="description"
          content="Join Bellefy Insights - opportunities to work with a mission-driven data and automation practice."
        />
      </Helmet>

      {/* Hero Section */}
      <section 
        id="intro" 
        style={{ 
          paddingTop: '150px', 
          paddingBottom: '100px', 
          minHeight: 'auto',
          backgroundImage: `linear-gradient(111deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${HeroImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundAttachment: 'fixed'
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col md={10}>
              <h1 className="text-center" style={{ color: '#ffffff', marginBottom: '1rem' }}>
                Work with Us
              </h1>
              <p className="text-center lead" style={{ color: '#ffffff' }}>
                Join our mission-driven team
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Join Our Team */}
      <section className="section-bg">
        <Container>
          <Row className="justify-content-center">
            <Col md={10}>
              <h2 className="cormorant-garamond text-center mb-4 gradient-text">Join Bellefy Insights</h2>
              <p className="text-center lead mb-5">
                We're always looking for talented individuals who share our passion for turning data into meaningful impact.
              </p>

              <Row className="mt-5">
                <Col md={6} className="mb-4">
                  <h3>Why Work with Us</h3>
                  <ul>
                    <li>Work on meaningful projects that drive social impact</li>
                    <li>Collaborate with NGOs, donors, and public-sector organizations</li>
                    <li>Opportunity to work with cutting-edge data technologies</li>
                    <li>Flexible and remote-friendly work environment</li>
                    <li>Continuous learning and professional development</li>
                    <li>Be part of a mission-driven team</li>
                  </ul>
                </Col>
                <Col md={6} className="mb-4">
                  <h3>What We're Looking For</h3>
                  <ul>
                    <li>Data analysts and data engineers</li>
                    <li>Dashboard and visualization specialists</li>
                    <li>M&E and performance management experts</li>
                    <li>Cloud migration and data integration specialists</li>
                    <li>AI and automation engineers</li>
                    <li>Project managers with data experience</li>
                  </ul>
                </Col>
              </Row>

              <div className="mt-5 text-center">
                <h3>Get in Touch</h3>
                <p>
                  Interested in joining our team? Send us your resume and a brief introduction.
                </p>
                <p>
                  Email: <a href="mailto:careers@bellefyinsights.com">careers@bellefyinsights.com</a>
                </p>
                <p>
                  We review applications on a rolling basis and will reach out if there's a good fit.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Partner with Us */}
      <section>
        <Container>
          <Row className="justify-content-center">
            <Col md={10}>
              <h2 className="cormorant-garamond text-center mb-4 gradient-text">Partner with Us</h2>
              <p className="text-center lead mb-4">
                At Bellefy Insights, we believe collaboration is the foundation of lasting impact. We welcome partnerships with organizations of all sizes and across all sectors to design and deliver solutions that create value and drive meaningful change.
              </p>
              <h3 className="text-center mb-3">Let's Explore Opportunities</h3>
              <p className="text-center mb-4">
                If your organization is interested in partnering or teaming on upcoming projects, please contact us at{' '}
                <a href="mailto:contact@bellefyinsights.com">contact@bellefyinsights.com</a>. You may wish to share:
              </p>
              <ul className="mb-4">
                <li>Areas of collaboration (e.g., monitoring & evaluation, data analytics, digital transformation, other)</li>
                <li>Country or region of interest</li>
                <li>Type of partnership you are exploring (teaming, subcontracting, joint initiative, etc.)</li>
              </ul>
              <p className="text-center">
                We will review your inquiry and get in touch to explore how we can work together.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default WorkWithUs;
